/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsViewModel } from './ContactDetailsViewModel';
import {
    ContactDetailsViewModelFromJSON,
    ContactDetailsViewModelFromJSONTyped,
    ContactDetailsViewModelToJSON,
} from './ContactDetailsViewModel';
import type { IndividualAddressesViewModel } from './IndividualAddressesViewModel';
import {
    IndividualAddressesViewModelFromJSON,
    IndividualAddressesViewModelFromJSONTyped,
    IndividualAddressesViewModelToJSON,
} from './IndividualAddressesViewModel';
import type { IndividualPartyDetailsViewModel } from './IndividualPartyDetailsViewModel';
import {
    IndividualPartyDetailsViewModelFromJSON,
    IndividualPartyDetailsViewModelFromJSONTyped,
    IndividualPartyDetailsViewModelToJSON,
} from './IndividualPartyDetailsViewModel';

/**
 * 
 * @export
 * @interface IndividualDetailsViewModel
 */
export interface IndividualDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof IndividualDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {IndividualPartyDetailsViewModel}
     * @memberof IndividualDetailsViewModel
     */
    policyHolderDetails?: IndividualPartyDetailsViewModel;
    /**
     * 
     * @type {ContactDetailsViewModel}
     * @memberof IndividualDetailsViewModel
     */
    contactDetails?: ContactDetailsViewModel;
    /**
     * 
     * @type {IndividualAddressesViewModel}
     * @memberof IndividualDetailsViewModel
     */
    addresses?: IndividualAddressesViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof IndividualDetailsViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the IndividualDetailsViewModel interface.
 */
export function instanceOfIndividualDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function IndividualDetailsViewModelFromJSON(json: any): IndividualDetailsViewModel {
    return IndividualDetailsViewModelFromJSONTyped(json, false);
}

export function IndividualDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndividualDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'policyHolderDetails': !exists(json, 'PolicyHolderDetails') ? undefined : IndividualPartyDetailsViewModelFromJSON(json['PolicyHolderDetails']),
        'contactDetails': !exists(json, 'ContactDetails') ? undefined : ContactDetailsViewModelFromJSON(json['ContactDetails']),
        'addresses': !exists(json, 'Addresses') ? undefined : IndividualAddressesViewModelFromJSON(json['Addresses']),
        'isComplete': json['IsComplete'],
    };
}

export function IndividualDetailsViewModelToJSON(value?: IndividualDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PolicyHolderDetails': IndividualPartyDetailsViewModelToJSON(value.policyHolderDetails),
        'ContactDetails': ContactDetailsViewModelToJSON(value.contactDetails),
        'Addresses': IndividualAddressesViewModelToJSON(value.addresses),
        'IsComplete': value.isComplete,
    };
}

